export const OffersCatalogSchema = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  "name": "تعرفه و قیمت مرکز تلفن ابری نواتل",
  "description": "لیست کامل تعرفه های بسته های مختلف مرکز تلفن ابری نواتل شامل بسته های برنزی، نقره ای، طلایی و اپال با پیش شماره های ۸ و ۹ رقمی.",
  "url": "https://navatel.ir/prices/",
  "itemListElement": [
    {
      "@type": "Offer",
      "name": "بسته برنزی مرکز تلفن ابری (پیش شماره ۸ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "5500000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته برنزی",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته نقره ای مرکز تلفن ابری (پیش شماره ۸ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "11000000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته نقره ای",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته طلایی مرکز تلفن ابری (پیش شماره ۸ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "22000000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته طلایی",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته اپال مرکز تلفن ابری (پیش شماره ۸ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "33000000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته اپال",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته برنزی مرکز تلفن ابری (پیش شماره ۹ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "5500000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته برنزی",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته نقره ای مرکز تلفن ابری (پیش شماره ۹ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "11000000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته نقره ای",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته طلایی مرکز تلفن ابری (پیش شماره ۹ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "22000000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته طلایی",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    },
    {
      "@type": "Offer",
      "name": "بسته اپال مرکز تلفن ابری (پیش شماره ۹ رقمی)",
      "category": "مرکز تلفن ابری",
      "price": "33000000",
      "priceCurrency": "IRR",
      "offeredBy": {
        "@type": "Organization",
        "name": "Navatel",
        "url": "https://navatel.ir/"
      },
      "itemOffered": {
        "@type": "Service",
        "name": "مرکز تلفن ابری نواتل - بسته اپال",
        "url": "https://navatel.ir/products/cloud-pbx/"
      }
    }
  ]
}